import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { BulkUploadPayload, ExternalDataPayload } from "./@types";

const createExternalData = async ( payload: BulkUploadPayload) => {
    const { data } = await apiInputService.post(`/ExternalData/updateMassive/file`, payload);

    return data;
}

export const useSubmitBulkUpload = (options?: any) => {
    return useMutation(createExternalData, {
        ...options,
    });
}